import { AsyncThunk, createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { filterDataAPI, filterTableDataAPI } from "services/CRUDServices"
import { getUrls } from "services/api.enums"

export const filterShiftDetail: AsyncThunk<{}, {}, {}> = createAsyncThunk(
  "shift-detail-managemnt",
  async (body: any) => {
    // delete body.pageNumber
    const data = await filterTableDataAPI(
      getUrls.freelancerShiftPreparation,
      body.pageNumber,
      { ...body, pageNumber: undefined, pageSize: undefined },
      true,
      10,
      false
    )
    return data.data.response
  }
)

const initialState: any = {
  shiftDetail: [],
  fetchpost: false,
  errorMessage: null,
  isUpdating: false,
  filter: {},
}

const ShiftDetailSlice = createSlice({
  initialState: initialState,
  name: "shift-detail-managemnt",
  reducers: {
    clearShiftDetail: (state) => {
      state.shiftDetail = []
    },
    setShiftDetailFilter: (state, action) => {
      state.filter = action.payload
    },

  },
  extraReducers: {
    [filterShiftDetail.fulfilled as any]: (state, action) => {
      state.shiftDetail = action.payload
      state.fetchpost = false
    },
    [filterShiftDetail.pending as any]: (state) => {
      state.fetchpost = true
    },
    [filterShiftDetail.rejected as any]: (state) => {
      state.fetchpost = false
      state.errorMessage = "wrong"
    },
  },
})

export const { setShiftDetailFilter, clearShiftDetail } =
  ShiftDetailSlice.actions
export default ShiftDetailSlice.reducer
